import { Row, Col, Table, Button, Space, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { deleteUser, impersonateUser, listAllUsers, manageUser } from "../../common/api/UserClient";
import { handleError } from "../../common/ErrorHandling";
import { useUserState } from "../../common/UserContext";
import { User, UserRole } from "../../types/UserGroup";
import { userRoleToTag } from "../user/UserAttributes";
import { UserUpdateModal } from "./components/UserUpdateModal";

const { Column } = Table;

export const UserImpersonationView: React.FC = () => {
    const [data, setData] = useState<User[]>([]);
    const [user, setUesr] = useState({} as User);
    const [showUpdate, setShowUpdate] = useState(false);
    const [loading, setLoading]: any[] = useState(true);
    const { refreshMe } = useUserState();

    const refreshUsers = async () => {
        setLoading(true);
        try {
            const users = await listAllUsers();
            setData(users);
        } catch (error) {
            handleError(error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        refreshUsers();
    }, []);

    const handleImpersonate = async (user: User) => {
        try {
            const res = await impersonateUser(user.id);
            refreshMe();
            return res;
        } catch (error) {
            handleError(error);
        }
    };

    const handleManage = (user: User) => {
        setUesr(user);
        setShowUpdate(true);
    };

    const handleUpdate = async (user: User) => {
        try {
            await manageUser(user);
            await refreshUsers();
        } catch (error) {
            handleError(error);
        } finally {
            setShowUpdate(false);
        }
    };

    const handleDelete = (user: User) => {
        Modal.confirm({
            title: "Are you sure to delete this user?",
            content: (
                <>
                    <div>Name: {user.name}</div>
                    <div>Email: {user.email}</div>
                </>
            ),
            closable: true,
            maskClosable: true,
            okText: "Confirm",
            onOk: async () => {
                try {
                    await deleteUser(user.id);
                    await refreshUsers();
                } catch (error) {
                    handleError(error);
                }
            },
        });
    };

    const userTable = (
        <Table size="small" dataSource={data} loading={loading} rowKey="id">
            <Column title="User Name" sorter={true} dataIndex="name" key="name" />
            <Column
                title="Orgnization Name"
                dataIndex="organization.name"
                key="orgnizatioName"
                render={(_, row: any) => row.organization?.name}
            />
            <Column title="Email" sorter={true} dataIndex="email" key="email" />
            <Column
                title="Roles"
                dataIndex="roles"
                render={(value: UserRole[]) => {
                    return value ? value.map((role: UserRole) => userRoleToTag(role)) : "";
                }}
            />
            <Column
                title="Impersonate"
                sorter={true}
                dataIndex="impersonate"
                key="impersonate"
                render={(value, row: User) => {
                    return (
                        <Space>
                            <Button type="primary" onClick={() => handleImpersonate(row)}>
                                Impersonate
                            </Button>
                            <Button onClick={() => handleManage(row)}>Manage</Button>
                            <Button danger onClick={() => handleDelete(row)}>
                                Delete
                            </Button>
                        </Space>
                    );
                }}
            />
        </Table>
    );

    const panel = (
        <div style={{ paddingTop: 10 }}>
            <hr />
            <UserUpdateModal
                user={user}
                open={showUpdate}
                onCancel={() => setShowUpdate(false)}
                onOk={handleUpdate}
            />
            <Row justify={"center"}>
                <Col span={24}>{userTable}</Col>
            </Row>
        </div>
    );

    return panel;
};
